import {createApp} from 'vue'
import {Store} from '../model/store/Store'
import {createRouter, createWebHashHistory} from 'vue-router';
import {sync} from 'vuex-router-sync'
import VueHead from 'vue-head'
import JhsFree from '../component/view/JhsFree.vue'
import JhsFreeInputProfile from "../component/pages/jhsfree/JhsFreeInputProfile.vue";
import JhsFreeLpRouter from '../component/router/JhsFreeLpRouter.vue'
import JhsFreeGuidanceLogin from "../component/pages/jhsfree/JhsFreeGuidanceLogin.vue";
import JhsFreeInputCertificate from '../component/pages/jhsfree/JhsFreeInputCertificate.vue'
import JhsFreeErrorEntryDuplicate from '../component/pages/jhsfree/JhsFreeErrorEntryDuplicate.vue'
import JhsFreeErrorEntryDenial from '../component/pages/jhsfree/JhsFreeErrorEntryDenial.vue'
import JhsFreeErrorEntryPenalty from '../component/pages/jhsfree/JhsFreeErrorEntryPenalty.vue'
import JhsFreeCompleted from '../component/pages/jhsfree/JhsFreeCompleted.vue'
import JhsFreeLastConfirm from "../component/pages/jhsfree/JhsFreeLastConfirm.vue";
import JhsFreeGraduation from "../component/pages/jhsfree/JhsFreeGraduation.vue";
import * as navigationGuard from "./navigationGuard/JhsFreeNavigationGuard"
import {sendViewEvent} from "../util/Ga4EventUtil";

const hasJhsFreeVoucher = document.getElementById('hasJhsFreeVoucher').textContent === 'true'
const description = `中学生限定！フリューのプリ機で撮影したプリ画が全部もらえちゃう☆ピクトリンクの「プレミアム会員特典」が無料で使えるサービスがスタート！`

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/lp'
        },
        {
            path: '/lp',
            component: JhsFreeLpRouter,
            props: {
                title: '中学生限定！無料でプリ画が全部もらえる！サービス - ピクトリンク',
                description: description,
            },
        },
        {
            path: '/guidance/login',
            component: JhsFreeGuidanceLogin,
            props: {
                title: '中学生ピクトリンク無料サービス - ピクトリンク',
                description: description
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkLoginStatus(next)
            },
        },
        {
            path: '/error/audition/duplicated',
            component: JhsFreeErrorEntryDuplicate,
            props: {
                title: '重複申込エラー - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの申込エラーです'
            }
        },
        {
            path: '/error/audition/denied',
            component: JhsFreeErrorEntryDenial,
            props: {
                title: '審査結果NG申込エラー - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの申込エラーです'
            }
        },
        {
            path: '/error/audition/penalty',
            component: JhsFreeErrorEntryPenalty,
            props: {
                title: '利用規約違反申込エラー - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの申込エラーです'
            }
        },
        {
            path: '/input/profile',
            component: JhsFreeInputProfile,
            beforeEnter: (to, from, next) => {
                navigationGuard.checkAuditionAvailable(next)
            },
            props: {
                title: '申込情報入力 - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの申込情報入力ページです'
            }
        },
        {
            path: '/input/certificate',
            component: JhsFreeInputCertificate,
            props: {
                title: '本人確認書類アップロード - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの応募フォーム（本人確認書類アップロードページ）です'
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkCertificate(next)
            }
        },
        {
            path: '/confirm/last',
            component: JhsFreeLastConfirm,
            props: {
                title: '申込内容最終確認 - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの応募内容確認ページです'
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkCompleteAll(next)
            }
        },
        {
            path: '/update/profile',
            component: JhsFreeInputProfile,
            props: {
                title: '申込情報の変更 - ピクトリンク',
                description: '申込情報の変更ページです',
                isChange: true
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkCompleteAll(next)
            }
        },
        {
            path: '/update/certificate',
            component: JhsFreeInputCertificate,
            props: {
                title: '本人確認書類の変更 - ピクトリンク',
                description: '本人確認書類の変更ページです',
                isChange: true
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkCompleteAll(next)
            }
        },
        {
            path: '/completed/audition',
            component: JhsFreeCompleted,
            props: {
                title: '申込完了 - ピクトリンク',
                description: '中学生ピクトリンク無料サービスの申込完了ページです',
            },
            beforeEnter: (to, from, next) => {
                navigationGuard.checkCompleteAll(next)
            }
        },
        {
            path: '/graduation',
            component: JhsFreeGraduation,
            props: {
                title: '中学生ピクトリンク無料サービスを利用中の中学3年生のみなさまへ - ピクトリンク',
                description: '中3の2月末で中学生ピクトリンク無料サービスの利用期間が終了して、全部のプリ画を無料でもらえなくなるよ！3月からも大事な思い出をプリで全部残そう！',
                hasJhsFreeVoucher: hasJhsFreeVoucher,
            },
        },
    ],
    scrollBehavior() {
        return {top: 0}
    },
});

router.afterEach((to) => {
    sendViewEvent(to.path)
})



// 初期化時にstoreをセットすることでnavigation guard発動のたびにAPI呼んでしまうのを防ぐ
sync(Store, router);
Promise.all([
    Store.dispatch('AccountStoreV2/getAccountStatus'),
    Store.dispatch('AccountStoreV2/setupIsAppli'),
]).then(() => {
    createApp(JhsFree)
        .use(Store)
        .use(router)
        .use(VueHead)
        .mount('#jhsFree');
});
